appSocial.controller('leadersComparePage', ['$scope', '$state', 'SocialLocaleService', 'SocialUtils', 'LeadersCompareService',
    function ($scope, $state, SocialLocaleService, SocialUtils, LeadersCompareService) {
        class LeadersComparePage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;
                this.utils = SocialUtils;
                /**
                 * @type {LeadersCompareService}
                 */
                this.compareService = LeadersCompareService;

                this.category = {
                    id: 'custom-search',
                    title: 'customSearch',
                    active: false,
                    show: false
                }
            }
        }

        return new LeadersComparePage()
    }]);
